import { render, staticRenderFns } from "./HumanSubjectsProtection.vue?vue&type=template&id=ffab48f2&"
import script from "./HumanSubjectsProtection.vue?vue&type=script&lang=js&"
export * from "./HumanSubjectsProtection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports